import { Injectable } from '@angular/core';
import { SSOLoginData } from 'src/app/common/models/SingleSignOn';
import { DictionaryStoreService } from '../dictionaryStore/dictionary-store.service';
import { Storage } from '@ionic/storage';

/**
 * Service che modifica i dati necessari per ottenere
 * le funzionalità di Single Sign On nell'applicazione
 * conservando i dati di login immessi dall'utente
 */
@Injectable({
  providedIn: 'root'
})
export class SsoService extends DictionaryStoreService<SSOLoginData> {

  protected getDbKey(): string {
    return '__ssoData';
  }

  protected areEntitiesEqual(a: SSOLoginData, b: SSOLoginData): boolean {
    return true; // Conservo sempre e solo una entita'
  }

  protected parseEntityFromString(entitiesAsString: string): SSOLoginData {
    return JSON.parse(entitiesAsString);
  }

  constructor(protected storage: Storage) {
    super(storage);
  }

  /**
   * Ritorna i dati precedentemente compilati nella pagina di
   * login  o stringhe vuote se è la prima compilazione
   */
  async getOldLoginData(): Promise<SSOLoginData> {
    const oldData = await this.getEntities();
    if (oldData == null) {
      return (new SSOLoginData());
    } else {
      return oldData[0];
    }
  }

  /**
   * Memorizza i nuovi dati di login compilati dall'utente
   * sul DB per essere riproposti
   * @param username
   * @param password
   * @param serverName ip associato al server del cliente
   */
  async setSSOLoginData(
    username: string,
    password: string,
    alias: string,
    serverName: string,
  ): Promise<void> {
    const newSSOLogin = new SSOLoginData();
    newSSOLogin.username = username;
    newSSOLogin.password = password;
    newSSOLogin.alias = alias;
    newSSOLogin.serverName = serverName;
    await this.addEntity(newSSOLogin);
  }

  /**
   * Funzione da invocare quando viene effettuato il logout
   * dall'applicazione in modo che alla prossima riapertura
   * non venga rifatto il login ma si auto compilino
   * alcuni dei vecchi dati
   */
  async setLogoutSSOStatus(): Promise<void> {
    const logoutData = await this.getOldLoginData();
    logoutData.password = '';
    await this.setSSOLoginData(
      logoutData.username,
      logoutData.password,
      logoutData.alias,
      logoutData.serverName);
  }
}